const toggle=document.querySelector('.menu-toggle');
const nav=document.querySelector('.mobile-nav');
// Banners at the top of the mobile menu: edit this list to swap campaigns (in Shopify: blocks of the header section).
const menuBanners=[
  {href:'pack.html?p=christmas-pack',img:'Packs/mp-christmas.webp',kicker:'Neu · 65 €',title:'CHRISTMAS PACK',bg:'#4e1312'},
  {href:'pack.html?p=mysterypacks-base',img:'Packs/mp-base.webp',kicker:'Bestseller · 65 €',title:'BASE PACK',bg:'#3b2a8f'},
  {href:'rewards.html',img:'Packs/mp-icon.webp',kicker:'Views gegen PACKs',title:'Reveal Rewards',bg:'#2e4dff'}
];
// Theme: the header section renders the banners itself.
if(!nav.querySelector('.mn-banners'))nav.insertAdjacentHTML('afterbegin',`<div class="mn-banners">${menuBanners.map(b=>`<a class="mn-banner" href="${b.href}" style="--bg:${b.bg}"><span class="mn-banner-copy"><small>${b.kicker}</small><strong>${b.title}</strong></span><img src="${b.img}" alt="" loading="lazy" decoding="async"></a>`).join('')}</div>`);
toggle.addEventListener('click',()=>{const open=nav.classList.toggle('open');toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Menü schließen':'Menü öffnen')});
nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('open');toggle.setAttribute('aria-expanded','false')}));
const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
const announcement=document.querySelector('.announcement');
if(!announcement){/* theme: the bar can be removed in the editor */}else if(reducedMotion){
  announcement.removeAttribute('role');
  announcement.removeAttribute('tabindex');
  announcement.removeAttribute('aria-pressed');
  announcement.setAttribute('aria-label','Shopvorteile');
}else{
  const toggleAnnouncement=()=>{
    const paused=announcement.classList.toggle('is-paused');
    announcement.setAttribute('aria-pressed',String(paused));
    announcement.setAttribute('aria-label',paused?'Shopvorteile: Laufband fortsetzen':'Shopvorteile: Laufband anhalten');
  };
  announcement.addEventListener('click',toggleAnnouncement);
  announcement.addEventListener('keydown',event=>{
    if(event.key==='Enter'||event.key===' '){event.preventDefault();toggleAnnouncement()}
  });
  // Each half of the loop must be at least as wide as the screen, or a gap opens before the seam.
  const announcementTrack=announcement.querySelector('.announcement-track');
  const announcementGroups=[...announcement.querySelectorAll('.announcement-group')];
  const announcementItems=[...announcementGroups[0].children];
  const fillAnnouncement=()=>{
    while(announcementGroups[0].offsetWidth<innerWidth+40){
      announcementGroups.forEach((group,index)=>announcementItems.forEach(item=>{
        const copy=item.cloneNode(true);
        if(index===0)copy.setAttribute('aria-hidden','true');
        group.append(copy);
      }));
    }
    // Constant speed (about 28px/s) whatever the group width.
    announcementTrack.style.animationDuration=`${Math.round(announcementGroups[0].offsetWidth/28)}s`;
  };
  fillAnnouncement();
  document.fonts?.ready.then(fillAnnouncement);
  window.addEventListener('resize',fillAnnouncement,{passive:true});
}

// Unboxing cards: hovering plays a muted preview (desktop with motion only); a click plays the video with sound.
const previewOk=matchMedia('(hover:hover) and (pointer:fine)').matches&&!matchMedia('(prefers-reduced-motion: reduce)').matches;
document.querySelectorAll('.video-card').forEach(card=>{if(!previewOk)return;const video=card.querySelector('video');if(!video)return;card.addEventListener('pointerenter',()=>{if(card.classList.contains('playing'))return;if(!video.src){video.src=video.dataset.src;video.load()}card.classList.add('is-preview');video.muted=true;video.play().catch(()=>{})});card.addEventListener('pointerleave',()=>{if(!card.classList.contains('is-preview'))return;card.classList.remove('is-preview');video.pause()})});
// Cards with own video and TikTok link (.has-preview): on touch devices the muted preview plays while the card is in view.
if(!previewOk&&'IntersectionObserver' in window&&!matchMedia('(prefers-reduced-motion: reduce)').matches){const io=new IntersectionObserver(entries=>entries.forEach(entry=>{const video=entry.target.querySelector('video');if(entry.isIntersecting){if(!video.src){video.src=video.dataset.src;video.load()}video.muted=true;video.play().catch(()=>{});entry.target.classList.add('is-preview')}else{video.pause();entry.target.classList.remove('is-preview')}}),{threshold:.6});document.querySelectorAll('.video-card.has-preview').forEach(card=>io.observe(card))}
// TikTok cards (data-tiktok): a click swaps the poster for TikTok's official embed player; the video stays on TikTok.
document.querySelectorAll('.video-card[data-tiktok]').forEach(card=>card.querySelector('button').addEventListener('click',()=>{document.querySelectorAll('.video-card video').forEach(v=>v.pause());card.querySelector('.video-frame').innerHTML=`<iframe src="https://www.tiktok.com/player/v1/${card.dataset.tiktok}?autoplay=1&music_info=0&description=0&rel=0" title="TikTok-Video" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>`;card.classList.add('playing')}));
document.querySelectorAll('.video-card:not([data-tiktok]):not(.has-preview)').forEach(card=>{const video=card.querySelector('video');const button=card.querySelector('button');button.addEventListener('click',()=>{card.classList.remove('is-preview');video.muted=false;document.querySelectorAll('.video-card video').forEach(other=>{if(other!==video)other.pause()});if(!video.src){video.src=video.dataset.src;video.load()}video.controls=true;video.play();card.classList.add('playing');video.focus({preventScroll:true})});video.addEventListener('play',()=>{if(!card.classList.contains('is-preview'))card.classList.add('playing')});video.addEventListener('error',()=>{card.classList.remove('playing');video.controls=false;button.setAttribute('aria-label','Video erneut laden')})});
const searchToggle=document.querySelector('.search-toggle');
const searchForm=document.querySelector('.site-search');
searchToggle.addEventListener('click',()=>{const open=searchForm.classList.toggle('open');searchToggle.setAttribute('aria-expanded',String(open));searchToggle.setAttribute('aria-label',open?'Suche schließen':'Suche öffnen');if(open)document.querySelector('#search-input').focus()});
document.querySelectorAll('.shop-nav details').forEach(item=>item.addEventListener('toggle',()=>{if(item.open)document.querySelectorAll('.shop-nav details').forEach(other=>{if(other!==item)other.open=false})}));
document.addEventListener('keydown',event=>{if(event.key==='Escape'){searchForm.classList.remove('open');searchToggle.setAttribute('aria-expanded','false');document.querySelectorAll('.shop-nav details').forEach(item=>item.open=false)}});
document.addEventListener('click',event=>{if(!event.target.closest('.site-header')){searchForm.classList.remove('open');searchToggle.setAttribute('aria-expanded','false');document.querySelectorAll('.shop-nav details').forEach(item=>item.open=false)}});
const heroVideo=document.querySelector('.hero-video');
const heroVideoArea=document.querySelector('.hero-visual');
// The poster carries the first paint; the video only starts after the page has loaded,
// and not at all on Data Saver or slow connections.
const slowNet=navigator.connection&&(navigator.connection.saveData||/2g|3g/.test(navigator.connection.effectiveType||''));
// Size by screen and connection: phones 480p, or 720p on a fast connection; larger screens 1080p (720p when slow).
const heroVideoSource=()=>{const d=heroVideo.dataset,down=navigator.connection&&navigator.connection.downlink||10,phone=matchMedia('(max-width: 700px)').matches;if(phone)return down>=8?d.srcMedium||d.src:d.srcSmall||d.srcMedium||d.src;return down<5?d.srcMedium||d.src:d.src};
if(heroVideo&&!reducedMotion&&!slowNet){
  const whenLoaded=fn=>document.readyState==='complete'?setTimeout(fn,300):addEventListener('load',()=>setTimeout(fn,300),{once:true});
  whenLoaded(()=>{
  const heroObserver=new IntersectionObserver(entries=>{
    const visible=entries[0].isIntersecting;
    if(visible&&!document.hidden){
      if(!heroVideo.src){heroVideo.src=heroVideoSource();heroVideo.load()}
      heroVideo.play().catch(()=>{});
    }else heroVideo.pause();
  },{threshold:.2});
  heroObserver.observe(heroVideoArea);
  heroVideo.addEventListener('playing',()=>{heroVideoArea.classList.add('video-ready')});
  heroVideo.addEventListener('error',()=>heroVideoArea.classList.remove('video-ready'));
  document.addEventListener('visibilitychange',()=>{if(document.hidden)heroVideo.pause();else if(heroVideo.src&&heroVideoArea.getBoundingClientRect().bottom>0&&heroVideoArea.getBoundingClientRect().top<innerHeight)heroVideo.play().catch(()=>{})});
  });
}
const stickyHeader=document.querySelector('.site-header');
const updateHeaderState=()=>stickyHeader.classList.toggle('is-scrolled',window.scrollY>10);
window.addEventListener('scroll',updateHeaderState,{passive:true});
updateHeaderState();
document.querySelectorAll('.shop-shelf').forEach(shelf=>{
  const shopTrack=shelf.querySelector('.shop-shelf-track');
  const previous=shelf.querySelector('.shop-shelf-prev');
  const next=shelf.querySelector('.shop-shelf-next');
  if(!shopTrack||!previous||!next)return;
  const updateShopControls=()=>{
    previous.disabled=shopTrack.scrollLeft<2;
    next.disabled=shopTrack.scrollLeft+shopTrack.clientWidth>=shopTrack.scrollWidth-2;
  };
  const moveShop=direction=>{
    const card=shopTrack.querySelector('.shop-card');
    const gap=parseFloat(getComputedStyle(shopTrack).columnGap)||0;
    shopTrack.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:reducedMotion?'instant':'smooth'});
  };
  previous.addEventListener('click',()=>moveShop(-1));
  next.addEventListener('click',()=>moveShop(1));
  shopTrack.addEventListener('scroll',updateShopControls,{passive:true});
  window.addEventListener('resize',updateShopControls,{passive:true});
  updateShopControls();
});
document.querySelectorAll('.shop-nav a').forEach(link=>link.addEventListener('click',()=>document.querySelectorAll('.shop-nav details').forEach(item=>item.open=false)));
// Small nav dropdowns open on hover like the PACKs menu; with data-href a mouse click on the label follows that link.
document.querySelectorAll('.info-menu').forEach(menu=>{
  const hover=matchMedia('(hover: hover) and (pointer: fine)');
  let timer;
  menu.addEventListener('pointerenter',e=>{if(hover.matches&&e.pointerType==='mouse'){clearTimeout(timer);menu.open=true}});
  menu.addEventListener('pointerleave',e=>{if(hover.matches&&e.pointerType==='mouse'){clearTimeout(timer);timer=setTimeout(()=>{menu.open=false},180)}});
  menu.querySelector('summary').addEventListener('click',e=>{if(hover.matches&&e.detail>0&&menu.dataset.href){e.preventDefault();location.href=menu.dataset.href}else if(hover.matches&&e.detail>0&&menu.open)e.preventDefault()});
});
const packsMenu=document.querySelector('.packs-menu');
if(packsMenu){
  const hoverMenu=matchMedia('(hover: hover) and (pointer: fine)');
  const packsSummary=packsMenu.querySelector('summary');
  const packsPanel=packsMenu.querySelector('.nav-panel');
  let closeTimer;
  const cancelClose=()=>clearTimeout(closeTimer);
  packsSummary.addEventListener('pointerenter',event=>{
    if(!hoverMenu.matches||event.pointerType!=='mouse')return;
    cancelClose();
    packsMenu.open=true;
  });
  packsSummary.addEventListener('click',event=>{
    if(hoverMenu.matches&&event.detail>0&&packsMenu.open)event.preventDefault();
  });
  packsPanel.addEventListener('pointerenter',cancelClose);
  packsMenu.addEventListener('pointerleave',event=>{
    if(!hoverMenu.matches||event.pointerType!=='mouse')return;
    cancelClose();
    closeTimer=setTimeout(()=>{if(!packsMenu.matches(':hover'))packsMenu.open=false},180);
  });
  // Preview card: shows the pack or collection under the pointer.
  const feature=packsMenu.querySelector('.mm-feature');
  if(feature){
    const featureImg=feature.querySelector('img');
    const featureName=feature.querySelector('strong');
    const featureMeta=feature.querySelector('.mm-feature-meta');
    const featureLine=feature.querySelector('.mm-feature-line');
    const featureLabel=feature.querySelector('.mm-feature-copy small');
    const initial={href:feature.href,img:featureImg.getAttribute('src'),name:featureName.textContent,meta:featureMeta.textContent,line:featureLine?.textContent||''};
    const links=[...packsMenu.querySelectorAll('.mm [data-img]')];
    const show=(data,link)=>{
      links.forEach(item=>item.classList.toggle('is-active',item===link));
      feature.href=data.href;featureName.textContent=data.name;featureMeta.textContent=data.meta;
      if(featureLine){featureLine.textContent=data.line||'';featureLine.hidden=!data.line}
      featureLabel.textContent=link?(link.classList.contains('mm-head')?'Kollektion':'PACK'):'Vorschau';
      if(featureImg.getAttribute('src')!==data.img)featureImg.src=data.img;
    };
    links.forEach(link=>{
      const data={href:link.href,img:link.dataset.img,name:link.dataset.name,meta:link.dataset.meta,line:link.dataset.line};
      link.addEventListener('pointerenter',()=>show(data,link));
      link.addEventListener('focus',()=>show(data,link));
    });
    packsMenu.addEventListener('toggle',()=>{if(packsMenu.open)show(initial,null)});
  }
}

const orbit=document.querySelector('.pack-orbit');
if(orbit){
  const stage=orbit.querySelector('.orbit-stage');
  const items=[...orbit.querySelectorAll('.orbit-pack')];
  const dots=[...orbit.querySelectorAll('.orbit-dot')];
  const count=items.length, wrap=n=>((n%count)+count)%count;
  let position=0,target=0,velocity=0,frame=0,lastTime=0,drag=null,suppressClick=false,index=-1;
  const gap=()=>Math.min(stage.clientWidth*(stage.clientWidth<650?.5:.195),285);
  const layout=()=>{
    items.forEach((item,i)=>{
      const offset=wrap(i-position+count/2)-count/2,depth=Math.abs(offset);
      item.style.transform=`translate(-50%,-50%) translate3d(${offset*gap()}px,${Math.min(depth,3)*26}px,0) rotate(${offset*-8}deg) scale(${Math.max(.4,1-depth*.17)})`;
      item.style.opacity=String(Math.max(0,Math.min(1,(3.8-depth)*.65)));
      item.style.zIndex=String(10-Math.round(depth*3));
      item.style.pointerEvents=depth>3.5?'none':'auto';
      item.tabIndex=depth>3.5?-1:0;
    });
  };
  const updateInfo=()=>{
    const next=wrap(target);if(next===index)return;index=next;
    const data=items[index].dataset;
    orbit.style.setProperty('--pack-glow',data.color);
    // Per-pack effect from data-fx on the slide (snow, claw); CSS picks it up from the section.
    orbit.dataset.fx=data.fx||'';
    const word=orbit.querySelector('.orbit-word');
    word.textContent=data.title.replace(/ PACKS?$/,'');
    orbit.querySelector('.orbit-info h2').textContent=data.title;
    orbit.querySelector('.orbit-info p').textContent=data.description;
    orbit.querySelector('.orbit-cta').href=data.link;
    orbit.querySelector('.orbit-status').textContent=`${data.title}, ${index+1} von ${count}`;
    items.forEach((item,i)=>item.setAttribute('aria-pressed',String(i===index)));
    dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
    if(!reducedMotion){
      [word,orbit.querySelector('.orbit-info')].forEach((element,i)=>{
        element.getAnimations().forEach(animation=>animation.cancel());
        element.animate([{opacity:0,transform:`translateY(${i?12:8}px)`},{opacity:i?1:.23,transform:'translateY(0)'}],{duration:i?360:550,easing:'cubic-bezier(.22,1,.36,1)'});
      });
    }
  };
  // Continuous coordinates keep the wrap behind the stage, even during rapid input.
  const tick=time=>{
    const dt=Math.min((time-lastTime)/1000||1/60,1/30);lastTime=time;
    const steps=4;
    for(let i=0;i<steps;i++){
      velocity+=((target-position)*190-velocity*25)*dt/steps;
      position+=velocity*dt/steps;
    }
    layout();
    if(Math.abs(target-position)>.0004||Math.abs(velocity)>.004)frame=requestAnimationFrame(tick);
    else{position=target;velocity=0;frame=0;layout()}
  };
  const settle=()=>{
    updateInfo();
    if(reducedMotion){cancelAnimationFrame(frame);frame=0;position=target;velocity=0;layout()}
    else if(!frame){lastTime=performance.now();frame=requestAnimationFrame(tick)}
  };
  const select=i=>{target+=wrap(i-wrap(target)+count/2)-count/2;settle()};
  items.forEach((item,i)=>item.addEventListener('click',()=>{if(!suppressClick)select(i)}));
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>select(i)));
  orbit.querySelector('.orbit-prev').addEventListener('click',()=>{target--;settle()});
  orbit.querySelector('.orbit-next').addEventListener('click',()=>{target++;settle()});
  stage.addEventListener('keydown',event=>{
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
      event.preventDefault();target+=event.key==='ArrowRight'?1:-1;settle();
    }
  });
  // Focus ring only after real keyboard use (Tab or arrows); clicks and drags never show it.
  orbit.addEventListener('pointerdown',()=>orbit.classList.remove('is-keys'),true);
  orbit.addEventListener('keydown',event=>{if(/^(Tab|Arrow|Enter| )/.test(event.key))orbit.classList.add('is-keys')},true);
  // Touch: own swipe handling (iOS cancels pointer drags), the row follows the finger and settles on release.
  let touch=null;
  stage.addEventListener('touchstart',event=>{
    if(event.target.closest('.orbit-arrow')||event.touches.length!==1)return;
    const t=event.touches[0];touch={x:t.clientX,y:t.clientY,start:position,horizontal:false,lastX:t.clientX,time:performance.now()};
    cancelAnimationFrame(frame);frame=0;velocity=0;
  },{passive:true});
  stage.addEventListener('touchmove',event=>{
    if(!touch)return;
    const t=event.touches[0],dx=t.clientX-touch.x,dy=t.clientY-touch.y;
    if(!touch.horizontal){
      if(Math.abs(dy)>10&&Math.abs(dy)>Math.abs(dx)){touch=null;return}
      if(Math.abs(dx)>8){touch.horizontal=true;stage.classList.add('is-dragging')}
    }
    if(touch.horizontal){
      event.preventDefault();
      const now=performance.now(),dt=Math.max(8,now-touch.time);
      velocity=velocity*.35+(-(t.clientX-touch.lastX)/gap()/(dt/1000))*.65;
      position=touch.start-dx/gap();touch.lastX=t.clientX;touch.time=now;suppressClick=true;layout();
    }
  },{passive:false});
  const touchEnd=()=>{
    if(!touch)return;
    if(touch.horizontal){stage.classList.remove('is-dragging');target=Math.round(position+Math.max(-1.5,Math.min(1.5,velocity*.18)));settle()}
    touch=null;
  };
  stage.addEventListener('touchend',touchEnd);stage.addEventListener('touchcancel',touchEnd);
  stage.addEventListener('pointerdown',event=>{
    if(event.pointerType==='touch'||event.target.closest('.orbit-arrow')||event.button!==0||!event.isPrimary)return;
    drag={id:event.pointerId,x:event.clientX,y:event.clientY,start:position,lastX:event.clientX,time:performance.now(),horizontal:false};
    suppressClick=false;
  });
  stage.addEventListener('pointermove',event=>{
    if(!drag||event.pointerId!==drag.id)return;
    const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
    if(!drag.horizontal&&Math.abs(dy)>10&&Math.abs(dy)>Math.abs(dx)){drag=null;return}
    if(!drag.horizontal&&Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy)){
      drag.horizontal=true;cancelAnimationFrame(frame);frame=0;velocity=0;
      drag.start=position;stage.setPointerCapture(event.pointerId);stage.classList.add('is-dragging');
    }
    if(drag.horizontal){
      const now=performance.now(),dt=Math.max(8,now-drag.time);
      velocity=velocity*.35+(-(event.clientX-drag.lastX)/gap()/(dt/1000))*.65;
      position=drag.start-dx/gap();drag.lastX=event.clientX;drag.time=now;
      suppressClick=true;layout();
    }
  });
  const release=event=>{
    if(!drag||event.pointerId!==drag.id)return;
    if(drag.horizontal){
      if(performance.now()-drag.time>90||event.type==='pointercancel')velocity=0;
      velocity=Math.max(-7,Math.min(7,velocity));
      target=Math.round(position+velocity*.13);
    }
    drag=null;stage.classList.remove('is-dragging');settle();
    setTimeout(()=>suppressClick=false,0);
  };
  stage.addEventListener('pointerup',release);
  stage.addEventListener('pointercancel',release);
  stage.addEventListener('lostpointercapture',release);
  new ResizeObserver(layout).observe(stage);settle();
}

// FAQ accordions: opening one answer closes the others in the same list.
document.querySelectorAll('.faq-list').forEach(list=>{
  list.addEventListener('toggle',event=>{
    const opened=event.target;
    if(opened.tagName!=='DETAILS'||!opened.open)return;
    list.querySelectorAll('details[open]').forEach(other=>{if(other!==opened)other.open=false});
  },true);
});

// Teams slider on phones: a real swipeable row that also drifts on by itself, endlessly.
// The logos are cloned once (aria-hidden); when the row has scrolled one full set it jumps back by that set,
// which looks seamless. Touching stops the drift so the row can be swiped; it resumes 2 s after letting go.
(()=>{
  const row=document.querySelector('.brands .brands-grid');
  if(!row||row.dataset.loop)return;
  row.dataset.loop='1';
  const originals=[...row.children];
  originals.forEach(li=>{const copy=li.cloneNode(true);copy.classList.add('is-clone');copy.setAttribute('aria-hidden','true');row.append(copy)});
  const phone=matchMedia('(max-width: 700px)');
  const still=matchMedia('(prefers-reduced-motion: reduce)');
  let touching=false,resumeAt=0,visible=false,last=0,pos=0;
  const setWidth=()=>originals.length?(row.children[originals.length].offsetLeft-row.children[0].offsetLeft):0;
  const wrap=()=>{const set=setWidth();if(set>0){if(row.scrollLeft>=set)row.scrollLeft-=set;else if(row.scrollLeft<=0&&touching===false)row.scrollLeft+=0}};
  new IntersectionObserver(([e])=>{visible=e.isIntersecting},{threshold:.3}).observe(row);
  row.addEventListener('touchstart',()=>{touching=true},{passive:true});
  const release=()=>{touching=false;resumeAt=performance.now()+2000;pos=row.scrollLeft};
  row.addEventListener('touchend',release);row.addEventListener('touchcancel',release);
  row.addEventListener('scroll',()=>{if(touching||performance.now()<resumeAt){wrap();pos=row.scrollLeft}},{passive:true});
  const tick=now=>{
    const dt=Math.min(64,now-last);last=now;
    if(phone.matches&&!still.matches&&visible&&!touching&&now>resumeAt&&!document.hidden){
      pos+=dt*0.035; // about 35 px per second
      const set=setWidth();if(set>0&&pos>=set)pos-=set;
      row.scrollLeft=pos;
    }
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(t=>{last=t;tick(t)});
})();

// Christmas section: live countdown to Christmas Eve (German date), hidden from 25 December on.
(()=>{
  const el=document.querySelector('.xmas-countdown');if(!el)return;
  const today=new Date(new Date().toLocaleString('en-US',{timeZone:'Europe/Berlin'}));
  const eve=new Date(today.getFullYear(),11,24);
  const days=Math.ceil((eve-new Date(today.getFullYear(),today.getMonth(),today.getDate()))/864e5);
  if(days<0)return;
  el.innerHTML=days===0?'<b>Heute</b> ist Heiligabend':`Noch <b>${days}</b> ${days===1?'Tag':'Tage'} bis Heiligabend`;
  el.hidden=false;
})();

// Christmas section snow: soft round flakes in three depths, falling and swaying; only runs while on screen.
(()=>{
  const canvas=document.querySelector('.xmas-snow-canvas');if(!canvas)return;
  const ctx=canvas.getContext('2d');const still=matchMedia('(prefers-reduced-motion: reduce)').matches;
  let flakes=[],w=0,h=0,running=false,last=0;
  const make=()=>{const z=Math.random();return{x:Math.random()*w,y:Math.random()*h,r:.8+z*2.6,v:12+z*38,s:Math.random()*6.28,a:.35+z*.55,sw:6+z*14}};
  const size=()=>{const dpr=Math.min(2,devicePixelRatio||1);w=canvas.clientWidth;h=canvas.clientHeight;canvas.width=w*dpr;canvas.height=h*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);const n=Math.round(w*h/9000);flakes=Array.from({length:n},make)};
  const draw=()=>{ctx.clearRect(0,0,w,h);for(const f of flakes){const g=ctx.createRadialGradient(f.x,f.y,0,f.x,f.y,f.r);g.addColorStop(0,`rgba(255,255,255,${f.a})`);g.addColorStop(1,'rgba(255,255,255,0)');ctx.fillStyle=g;ctx.beginPath();ctx.arc(f.x,f.y,f.r,0,6.283);ctx.fill()}};
  const tick=now=>{if(!running)return;const dt=Math.min(.05,(now-last)/1000);last=now;for(const f of flakes){f.y+=f.v*dt;f.s+=dt*.9;f.x+=Math.sin(f.s)*f.sw*dt;if(f.y>h+4){f.y=-4;f.x=Math.random()*w}}draw();requestAnimationFrame(tick)};
  size();draw();addEventListener('resize',()=>{size();draw()});
  if(still)return;
  new IntersectionObserver(([e])=>{if(e.isIntersecting&&!running){running=true;last=performance.now();requestAnimationFrame(tick)}else if(!e.isIntersecting)running=false}).observe(canvas);
})();

// Advantages on phones: the swipe row moves on by itself, one card every 4 s; touching pauses it.
(()=>{
  const row=document.querySelector('main .trust-grid');if(!row)return;
  const phone=matchMedia('(max-width: 700px)');const still=matchMedia('(prefers-reduced-motion: reduce)');
  let visible=false,resumeAt=0;
  new IntersectionObserver(([e])=>{visible=e.isIntersecting},{threshold:.5}).observe(row);
  const hold=()=>{resumeAt=performance.now()+6000};
  row.addEventListener('touchstart',hold,{passive:true});row.addEventListener('pointerdown',hold);
  setInterval(()=>{
    if(!phone.matches||still.matches||!visible||document.hidden||performance.now()<resumeAt)return;
    const card=row.children[0];if(!card)return;
    const step=card.getBoundingClientRect().width+(parseFloat(getComputedStyle(row).columnGap)||0);
    const end=row.scrollLeft+row.clientWidth>=row.scrollWidth-4;
    row.scrollTo({left:end?0:row.scrollLeft+step,behavior:'smooth'});
  },4000);
})();
